module.exports = __webpack_public_path__ + "static/media/r48.7bfc2f5c.jpg";